import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["option"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ComboboxOption, ComboboxOptions } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import AccessCandidateItem from './AccessCandidateItem';

/**
 * Anchored under the field and portalled out of the dialog, so it neither pushes
 * the sections below out of reach nor gets clipped by the dialog's own overflow.
 * It flips above the field by itself when there is no room under it.
 *
 * The height cap has to be the anchor variable rather than a max-h class:
 * anchoring writes an inline `max-height: min(var(--anchor-max-height), <space
 * below>)`, and an inline style wins against a class.
 *
 * The stable gutter keeps the thumb off the names rather than over them.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var ACCESS_CANDIDATE_PANEL_CLASSES = 'scrollbar scrollbar-contrast scrollbar-gutter-stable z-50 w-(--input-width) rounded-lg bg-white py-2 shadow-lg [--anchor-max-height:18rem] focus:outline-hidden dark:bg-gray-300';
/**
 * One row, as the virtualiser hands it over.
 *
 * Everything but `option` is passed straight through, and has to be: the
 * virtualiser clones this row to place it, so the absolute positioning and the
 * index attributes arrive as props. A component that keeps them to itself leaves
 * every row in normal flow inside a spacer thousands of pixels tall, which empties
 * the list as soon as it scrolls.
 *
 * Full width for the same reason — the row is positioned with no width of its own,
 * so it, and with it the hover, would otherwise stop at the end of the name.
 */
var AccessCandidateOption = function AccessCandidateOption(_ref) {
  var option = _ref.option,
    positioning = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ComboboxOption, _objectSpread(_objectSpread({}, positioning), {}, {
    value: option,
    className: function className(_ref2) {
      var focus = _ref2.focus;
      return twMerge('w-full cursor-pointer', focus && 'darken-10');
    },
    children: /*#__PURE__*/_jsx(AccessCandidateItem, {
      extensionKey: option
    })
  }));
};

/**
 * Rows come from the combobox's virtualiser, so a customer of several hundred
 * colleagues mounts a screenful rather than all of them — each row subscribes to
 * the store for its name and avatar, which is what made opening the list drag.
 */
var AccessCandidateList = function AccessCandidateList() {
  return /*#__PURE__*/_jsx(ComboboxOptions, {
    anchor: {
      to: 'bottom start',
      gap: 4
    },
    modal: false
    // Not modal: Headless UI otherwise marks the rest of the dialog
    // inert while the list is open, which took the members list, the tier
    // select and Done out of reach — a click on a member's remove button
    // did nothing at all. The list still closes on an outside click.
    ,
    className: ACCESS_CANDIDATE_PANEL_CLASSES,
    children: function children(slot) {
      return /*#__PURE__*/_jsx(AccessCandidateOption, {
        option: slot.option
      });
    }
  });
};
export default AccessCandidateList;